import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { client as backend } from '@hum/common/src/api/client';
import { AvailableServiceInfo } from './base';
import { openOAUthWindow2 } from '@hum/icm-app/src/utils';

const googleAdsenseOauthUrl = async () => {
  try {
    return await backend.get(`/connector/oauth/google/adsense`);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }
};

export const googleAdsenseOAuthConnector: AvailableServiceInfo = {
  label: 'Google Adsense',
  icon: require('./google_adsense.svg'),
  type: ConnectorType.GoogleAdsense,
  source: ConnectorSource.Capital,
  isBeta: true,
  async connect() {
    const oauthUrl = await googleAdsenseOauthUrl();
    const { code, scope } = await openOAUthWindow2(oauthUrl);
    return {
      code,
      scopes: scope,
    };
  },
};
